import { useState } from 'react';

import { ICONS, ICON_TYPES } from '@/src/components/common/Elements/Icon/Icon';
import { ACTION_POSITIONS, MODAL_TYPE } from '@/src/components/common/Elements/Modal/Config';
import useConfirmPopup, {
  UseConfirmPopupProps,
} from '@/src/components/common/Elements/Modal/useConfirmPopup';
import { ERRORS } from '@/src/components/main/app/Config';

import useDiscardChanges from './useDiscardChanges';

import { DEFAULT_PUBLISH_ERROR } from '../../Config';

const useTreatmentConfirmModals = () => {
  const [errorPopup, setErrorPopup] = useState<UseConfirmPopupProps>({
    ...DEFAULT_PUBLISH_ERROR,
  });

  const [ConfirmSuccessModal, confirmSuccess] = useConfirmPopup({
    classNames: '',
    modalWidth: '600px',
    actionPosition: ACTION_POSITIONS.end,
    title: 'Entry has been successfully published to Quickbooks',
    message: `Do you want to proceed printing?`,
    cancelBtn: {
      label: 'Not Now',
    },
    confirmBtn: {
      label: 'Print from Quickbooks',
    },
  });
  const [ConfirmErrorModal, confirmError] = useConfirmPopup({
    classNames: '',
    modalWidth: '600px',
    confirmBtn: {
      label: 'Okay',
    },
    ...errorPopup,
  });
  const [ConfirmDeleteDraftModal, confirmDeleteDraft] = useConfirmPopup({
    classNames: '',
    modalWidth: '600px',
    modalType: MODAL_TYPE.danger,
    title: 'Delete this draft?',
    icon: { icon: ICONS.delete },
    message: `This action cannot be undone.`,
    confirmBtn: {
      label: 'Yes, delete.',
    },
  });
  const [ConfirmClearDataModal, confirmClearData] = useConfirmPopup({
    classNames: '',
    modalWidth: '600px',
    modalType: MODAL_TYPE.danger,
    title: 'Clear Data?',
    icon: { icon: ICONS.info, iconType: ICON_TYPES.outlined },
    message: `Any inputs made will be removed.`,
    confirmBtn: {
      label: 'Yes, clear all.',
    },
  });
  const [DiscardChangesModal, confirmDiscard] = useDiscardChanges();
  const [CancelAutomationModal, confirmCancelAutomation] = useConfirmPopup({
    classNames: '',
    modalWidth: '600px',
    modalType: MODAL_TYPE.danger,
    actionPosition: ACTION_POSITIONS.end,
    title: 'Cancel automation?',
    icon: { icon: ICONS.info, iconType: ICON_TYPES.outlined },
    message: `No draft will be created/saved.`,
    confirmBtn: { label: 'Proceed' },
    cancelBtn: { label: 'Disregard' },
  });

  const [NetworkErrorModal, confirmNetworkError] = useConfirmPopup({
    classNames: '',
    modalWidth: '600px',
    confirmBtn: false,
    cancelBtn: {
      label: 'Okay',
    },
    actionPosition: ACTION_POSITIONS.end,
    modalType: MODAL_TYPE.danger,
    icon: { icon: ICONS.warning_amber, iconType: ICON_TYPES.outlined },
    ...ERRORS.NETWORK_ERROR,
  });

  return {
    ConfirmSuccessModal,
    ConfirmErrorModal,
    ConfirmDeleteDraftModal,
    ConfirmClearDataModal,
    DiscardChangesModal,
    CancelAutomationModal,
    NetworkErrorModal,
    confirmSuccess,
    confirmError,
    confirmDeleteDraft,
    confirmClearData,
    confirmDiscard,
    confirmCancelAutomation,
    setErrorPopup,
    confirmNetworkError,
  };
};

export default useTreatmentConfirmModals;
